import { customElement } from 'lit/decorators';
import { css, html, LitElement } from 'lit';
import { center, padding, row } from '../styles';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import configOverlay from './assets/config-overlay.webp';
import CodeIcon from '@carbon/web-components/es/icons/code/16';
import { annotation } from './common';

@customElement('pdq-tutorial-config-overlay')
class PDQTutorialConfigOverlay extends LitElement {
  static styles = [
    row,
    center,
    padding,
    annotation,
    css`
        .key-cap {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 4px 8px;
            font-family: monospace;
            font-size: 0.875rem;
            line-height: 1.5;
            border: 1px solid var(--cds-interactive-04, #8a3ffc);
            background-color: var(--cds-field-01, #f4f4f4);
            color: var(--cds-text-01, #161616);
            border-radius: 4px;
            max-width: 27px;
            margin: 4px
        }

    `];

  render() {
    const code = `<pdq-json id="people"><template>
[
  {
    "name": "Alice",
    "age": 25
  },
  {
    "name": "Bob",
    "age": 30
  },
  {
    "name": "Charley",
    "age": 30
  }
]
</template></pdq-json>`;
    const code2 = `<pdq-perspective-viewer height="120px" table="people"></pdq-perspective-viewer>`;

    return html`
      <cds-tile class="col">

        <h2>Config Overlay</h2>
        <p>Many pdq elements are completely inadvisable on the page, and even the ones that render have config that
          is not rendered.</p>

        ${unsafeHTML(code)}
        ${unsafeHTML(code2)}


        <h3>Show the config overlay...</h3>

        <div class="row">
          <div class="key-cap">ALT</div>
          <p>You can temporarily view all pdq elelemtns on the page by pressing and holding the alt key</p>
        </div>


        <div class="row">
          <div class="key-cap">ALT</div>
          <p>+</p>
          <div class="key-cap">CTRL</div>
          <p>Alt + Ctrl will toggle the config overlay, allowing the config to be tweeked</p>
        </div>


        <p>Each components overlay has config options and the ablity to copy the web-compoenent html
          so that it can be pasted on a new page</p>

        <img src="${configOverlay}" alt="">

        <p>To demonstrate the live and connected nature of hte data components, hit alt+ctrl now, and change the
          age or name of alice in the
          <cds-tag type="green">${CodeIcon({ slot: 'icon' })}pdq-json</cds-tag>
          ,
          then hit save...
        </p>

        <p>You should see the
          <cds-tag type="green">${CodeIcon({ slot: 'icon' })}pdq-perspective-viewer</cds-tag>
          update immediately
        </p>

        <p>Options presented in the config overlay, will depend on the nature of the component. Static data allows save,
          dynamic or remote data refresh etc.</p>
      </cds-tile>
    `;
  }
}